export const getFormattedFeeRate = (feeRate: bigint) => `${Number(feeRate) / 10000}%`
